module.exports = __webpack_public_path__ + "img/direction-3@3x.f89b8fb2.png";